module.exports = __webpack_public_path__ + "static/logo-baska-75a945f273ad42f01110b824e8ce75ca.png";